import type { CommonResources } from './en.js';

/** النصوص العربية المشتركة بين التطبيقات الثلاثة (namespace "common"). */
export const commonAr: CommonResources = {
  appName: 'عربات POS',
  interfaces: {
    manager: 'الإدارة',
    pos: 'نقطة البيع',
    platform: 'إدارة المنصة',
  },
  language: {
    label: 'اللغة',
    ar: 'العربية',
    en: 'English',
  },
  lock: {
    title: 'نقطة البيع مقفلة',
    body: 'أدخل كلمة المرور للمتابعة. أي شخص آخر يجب أن يدخل بحسابه الخاص.',
    unlock: 'فتح القفل',
    otherUser: 'الدخول بحساب آخر',
    lockNow: 'قفل',
  },
  actions: {
    close: 'إغلاق',
    retry: 'إعادة المحاولة',
    signIn: 'تسجيل الدخول',
    signOut: 'تسجيل الخروج',
    back: 'رجوع',
    openMenu: 'فتح القائمة',
    closeMenu: 'إغلاق القائمة',
  },
  status: {
    loading: 'جارٍ التحميل…',
    apiOnline: 'الخادم متصل',
    apiDegraded: 'الخادم يعمل جزئياً',
    apiOffline: 'تعذّر الوصول إلى الخادم',
    apiChecking: 'جارٍ فحص الخادم…',
  },
  auth: {
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور',
    passwordHint: '10 أحرف على الأقل.',
    passwordsDiffer: 'كلمتا المرور غير متطابقتين.',
    fullName: 'الاسم الكامل',
    showPassword: 'إظهار',
    hidePassword: 'إخفاء',
    forgotPassword: 'نسيت كلمة المرور؟',
    backToSignIn: 'العودة لتسجيل الدخول',
    chooseMerchant: 'اختر الشركة',
    chooseBranch: 'اختر الفرع',
    forgotTitle: 'إعادة تعيين كلمة المرور',
    forgotBody: 'أدخل بريدك الإلكتروني. إذا كان هناك حساب فسنرسل رابط إعادة التعيين.',
    forgotSend: 'إرسال الرابط',
    forgotSent: 'إذا كان هناك حساب لهذا البريد فقد أُرسل رابط إعادة التعيين. تحقق من بريدك.',
    resetTitle: 'اختر كلمة مرور جديدة',
    resetSubmit: 'حفظ كلمة المرور',
    resetDone: 'تم تغيير كلمة المرور. سجّل الدخول بكلمة المرور الجديدة.',
    resetMissingToken: 'رابط إعادة التعيين غير مكتمل. اطلب رابطاً جديداً.',
    useOtherApp: 'حسابك مخصص لتطبيق آخر.',
    openApp: 'افتح {{app}}',
    mfaTitle: 'التحقق الثنائي',
    mfaBody: 'أدخل الرمز المكوّن من 6 أرقام من تطبيق المصادقة.',
    mfaCode: 'رمز التحقق',
    verify: 'تحقق',
    noAccount: 'شركة جديدة؟',
    createAccount: 'إنشاء حساب',
    haveAccount: 'لديك حساب؟',
    accessDenied: 'ليست لديك صلاحية لعرض هذه الصفحة.',
    switchTo: 'الانتقال إلى {{app}}',
  },
  invite: {
    title: 'انضم إلى فريقك',
    intro: '{{name}}، تمت دعوتك للانضمام إلى {{company}} بالبريد',
    existing: 'يوجد حساب بهذا البريد مسبقاً. أكّد بكلمة المرور الحالية.',
    submit: 'قبول الدعوة',
    done: 'حسابك جاهز. يمكنك تسجيل الدخول الآن.',
    invalid: 'رابط الدعوة غير مكتمل.',
  },
  input: {
    wholeNumber: 'أدخل رقمًا صحيحًا من {{min}} إلى {{max}}.',
    wholeNumberMin: 'أدخل رقمًا صحيحًا لا يقل عن {{min}}.',
  },
  theme: {
    label: 'المظهر',
    light: 'فاتح',
    dark: 'داكن',
    system: 'تلقائي',
  },
  nav: {
    comingSoon: 'قريباً في {{milestone}}',
  },
  paging: {
    previous: 'السابق',
    next: 'التالي',
    pageOf: 'صفحة {{page}} من {{pages}}',
  },
  invoice: {
    print: 'طباعة الفاتورة',
    pdf: 'تحميل PDF',
    failed: 'تعذّر تجهيز الفاتورة. حاول مرة أخرى.',
    title: 'فاتورة {{number}}',
    send: 'إرسال للزبون على الواتساب',
    sharePdf: 'مشاركة PDF',
    shareReady: 'شارك الملف الآن',
    call: 'اتصال بالزبون',
    message: 'مرحباً {{name}}، شكراً لطلبك من {{store}}. فاتورة طلبك {{number}}: {{url}}',
    downloaded: 'المتصفح لا يدعم مشاركة الملفات، تم تحميل الملف بدلاً من ذلك.',
    tapAgain: 'الملف جاهز، اضغط «شارك الملف الآن».',
    notFound: 'الفاتورة غير موجودة',
    notFoundHint: 'تأكد من الرابط، أو اطلب من المتجر إرساله مرة أخرى.',
  },
  errors: {
    title: 'حدث خطأ ما',
    notFoundTitle: 'الصفحة غير موجودة',
    notFoundBody: 'الصفحة التي تبحث عنها غير موجودة.',
    requestId: 'رقم المرجع: {{id}}',
    UNAUTHENTICATED: 'يرجى تسجيل الدخول للمتابعة.',
    FORBIDDEN: 'ليست لديك صلاحية لتنفيذ هذا الإجراء.',
    VALIDATION_FAILED: 'بعض الحقول غير صحيحة، يرجى مراجعتها.',
    NOT_FOUND: 'العنصر المطلوب غير موجود.',
    ROUTE_NOT_FOUND: 'العنوان المطلوب غير موجود.',
    CONFLICT: 'تم تعديل هذا السجل من مستخدم آخر. أعد التحميل وحاول مجدداً.',
    RATE_LIMITED: 'محاولات كثيرة. يرجى الانتظار ثم المحاولة.',
    SERVICE_UNAVAILABLE: 'الخدمة غير متاحة مؤقتاً.',
    INVALID_CREDENTIALS: 'البريد الإلكتروني أو كلمة المرور غير صحيحة.',
    ACCOUNT_DISABLED: 'هذا الحساب معطّل. تواصل مع مديرك.',
    NO_MERCHANT_ACCESS: 'حسابك غير مفعّل في أي شركة.',
    INTERFACE_NOT_PERMITTED: 'ليست لديك صلاحية لهذا التطبيق.',
    PASSWORD_REQUIRED:
      'دخلت بالرقم السري (PIN). سجّل الدخول ببريدك وكلمة المرور لفتح تطبيق الإدارة أو شركة أخرى.',
    TICKET_INVALID: 'انتهت صلاحية هذه الخطوة. سجّل الدخول مجدداً.',
    MFA_INVALID: 'رمز التحقق غير صحيح.',
    RESET_TOKEN_INVALID: 'رابط إعادة التعيين غير صالح أو منتهي.',
    EMAIL_ALREADY_REGISTERED: 'هذا البريد مسجّل مسبقاً. سجّل الدخول أو أعد تعيين كلمة المرور.',
    VERSION_CONFLICT: 'تم تعديل هذا السجل من مستخدم آخر. أعد التحميل وحاول مجدداً.',
    PRIVILEGE_ESCALATION: 'لا يمكنك منح صلاحيات تتجاوز صلاحياتك.',
    INVITATION_INVALID: 'الدعوة غير صالحة أو منتهية أو مستخدمة.',
    LAST_SUPER_ADMIN:
      'لا يمكن ذلك لأنه لن يبقى مسؤول أعلى نشط. رقِّ أو فعِّل مسؤولًا أعلى آخر أولًا.',
    OPERATOR_SELF_CHANGE: 'لا يمكنك إيقاف حسابك أو تغيير دورك بنفسك.',
    ROLE_IN_USE: 'هذا الدور ما زال مُسنداً لموظفين أو دعوات.',
    DUPLICATE_CODE: 'هذا الرمز مستخدم مسبقاً.',
    ALREADY_MEMBER: 'هذا الشخص موظف في الشركة مسبقاً.',
    DUPLICATE_SKU: 'رمز SKU مستخدم لمنتج آخر.',
    DUPLICATE_BARCODE: 'الباركود مستخدم لمنتج آخر.',
    INVALID_PRICE: 'مبلغ غير صالح: حتى 3 خانات عشرية.',
    UNSUPPORTED_MEDIA: 'يُقبل JPEG وPNG وWebP فقط.',
    INSUFFICIENT_STOCK: 'الكمية المتوفرة غير كافية لصنف أو أكثر.',
    NOT_STOCK_TRACKED: 'لا يمكن تعديل بعض الأصناف: المخزون غير متتبَّع أو الصنف مؤرشف.',
    OPENING_STOCK_EXISTS: 'تم إدخال الرصيد الافتتاحي لهذا الصنف مسبقًا. استخدم تعديلًا أو جردًا.',
    INVALID_QUANTITY: 'كمية غير صالحة: أدخل رقمًا موجبًا بحد أقصى 3 خانات عشرية.',
    IDEMPOTENCY_CONFLICT: 'تم إرسال هذا الطلب سابقًا بمحتوى مختلف. أعد تحميل الصفحة وحاول مجددًا.',
    BRANCH_INACTIVE: 'هذا الفرع غير نشط.',
    SHIFT_REQUIRED: 'افتح وردية أولًا.',
    SHIFT_ALREADY_OPEN: 'لديك وردية مفتوحة بالفعل.',
    REGISTER_BUSY: 'هذا الصندوق مستخدم في وردية أخرى.',
    NOT_PRIMARY_DEVICE: 'الجهاز المربوط بصندوق وحده يفعل هذا (الوردية، النقد، فواتير المتصفح).',
    CASH_NOT_ALLOWED: 'هذا الجهاز بلا درج نقد: بطاقة أو تحويل فقط.',
    REGISTER_BOUND: 'هذا الصندوق مربوط بجهاز آخر، أو الجهاز ما زال مربوطاً. فُكّ الربط أولاً.',
    PIN_LINK_INVALID: 'رابط الدخول هذا لم يعد صالحاً. اطلب الرابط الجديد من مديرك.',
    PIN_NOT_SET: 'ليس لديك رقم سري بعد. عيّنه من تطبيق الكاشير ثم حاول مرة أخرى.',
    DISCOUNT_ARCHIVED: 'هذا الخصم مؤرشف ولا يمكن تعديله.',
    DOMAINS_UNAVAILABLE: 'ربط دومينك الخاص غير متاح بعد.',
    DOMAINS_PROVIDER_ERROR: 'خدمة الدومينات لم تستجب. حاول بعد دقائق.',
    DOMAIN_SEARCH_UNAVAILABLE: 'البحث عن الدومينات غير متاح بعد.',
    DOMAIN_NOT_ALLOWED: 'هذا الدومين تابع لعربات. اكتب الدومين الذي اشتريته.',
    DOMAIN_TAKEN: 'هذا الدومين مربوط بمتجر آخر.',
    WHATSAPP_UNAVAILABLE: 'رسائل الواتساب غير متاحة بعد.',
    WHATSAPP_NOT_VERIFIED: 'أكّد رقم الواتساب بالرمز أولاً.',
    WHATSAPP_SEND_FAILED: 'تعذّر إرسال الرمز على الواتساب. تأكد أن الرقم عليه واتساب.',
    CODE_RESEND_TOO_SOON: 'انتظر قليلاً قبل إرسال رمز جديد.',
    CODE_EXPIRED: 'انتهت صلاحية الرمز. أرسل رمزاً جديداً.',
    CODE_TOO_MANY_ATTEMPTS: 'محاولات كثيرة. أرسل رمزاً جديداً.',
    CODE_INVALID: 'الرمز غير صحيح.',
    DOMAIN_ALREADY_CONNECTED: 'احذف الدومين المربوط أولاً.',
    DOMAIN_NOT_ACTIVE: 'يصبح الدومين العنوان الأساسي بعد أن يعمل.',
    STORE_NOT_SAVED: 'احفظ إعدادات المتجر أولاً.',
    GOOGLE_CONNECT_UNAVAILABLE: 'الربط مع Google غير متاح حالياً.',
    STORE_NOT_PUBLISHED: 'انشر المتجر أولاً.',
    CUSTOM_DOMAIN_REQUIRED:
      'ميزات Google تشتغل بعد ما تربط دومينك الخاص ويصير العنوان الأساسي لمتجرك.',
    DUPLICATE_HANDLE: 'هذا الرابط مستخدم لصفحة أخرى في متجرك.',
    REGISTER_INACTIVE: 'هذا الصندوق غير نشط.',
    REGISTER_ACCESS_DENIED: 'غير مسموح لك باستخدام هذا الصندوق.',
    SHIFT_CLOSED: 'هذه الوردية مغلقة بالفعل.',
    INVALID_BREAKDOWN: 'عدد الأوراق والعملات لا يطابق الإجمالي.',
    INSUFFICIENT_CASH: 'لا يحتوي الدرج على هذا المبلغ من النقد.',
    INSUFFICIENT_TREASURY_CASH: 'لا تحتوي الخزينة على هذا المبلغ من النقد.',
    TREASURY_NOT_COUNTED: 'سجّل الجرد الافتتاحي للخزينة أولاً.',
    EXPECTED_CHANGED: 'تغيّر الرصيد في هذه الأثناء. أعد العدّ.',
    REGISTER_HAS_CASH: 'انقل النقد من الصندوق أولاً.',
    TRANSFER_NOT_ALLOWED: 'هذا التحويل النقدي غير مسموح.',
    INVALID_DISCOUNT: 'خصم غير صالح.',
    DISCOUNT_LIMIT_EXCEEDED: 'هذا الخصم يتجاوز الحد المسموح لك. اطلب مشرفًا.',
    PRICE_OVERRIDE_DENIED: 'غير مسموح لك بتعديل الأسعار.',
    PRICE_OUT_OF_BOUNDS: 'هذا السعر خارج الحدود التي حددتها الشركة لتعديل الأسعار.',
    ZERO_TOTAL_DENIED: 'عملية البيع بدون مبلغ تحتاج إلى مشرف.',
    REASON_REQUIRED: 'يجب ذكر سبب لهذا الإجراء.',
    OVERRIDE_INVALID: 'انتهت صلاحية موافقة المشرف أو سبق استخدامها. اطلبها مجددًا.',
    OVERRIDE_SELF: 'يجب أن تأتي موافقة المشرف من شخص آخر.',
    OVERRIDE_NOT_ALLOWED: 'لا يملك هذا الشخص صلاحيات تتجاوز صلاحياتك هنا.',
    REFERENCE_REQUIRED: 'أدخل مرجع جهاز الدفع أو التحويل لهذه الدفعة.',
    SETTLEMENT_ACCOUNT_REQUIRED:
      'طريقة الدفع هذه بلا حساب تسوية. اطلب من المدير ربط حساب قبل استخدامها.',
    PAYMENT_TOTAL_MISMATCH: 'مجموع الدفعات لا يساوي الإجمالي.',
    TOTAL_CHANGED: 'تغيّرت الأسعار. راجع عملية البيع وحاول مجددًا.',
    PAYMENT_NOT_VERIFIED: 'لا يمكن التحقق من هذه الدفعة حاليًا.',
    PAYMENT_METHOD_UNAVAILABLE: 'طريقة الدفع هذه غير متاحة.',
    ITEM_UNAVAILABLE: 'بعض الأصناف غير متاحة للبيع في هذا الفرع.',
    ORDER_NOT_SUSPENDED: 'تم إتمام أو حذف عملية البيع المعلّقة هذه.',
    REFUND_EXCEEDS_SALE: 'هذا أكثر مما يمكن إرجاعه من هذه العملية.',
    REFUND_ALLOCATION_INVALID: 'لا يمكن إعادة المبلغ بهذه الطريقة.',
    REFUND_NOT_PENDING: 'لم يعد هذا الاسترجاع بانتظار قرار.',
    NOT_VOIDABLE: 'يمكن إلغاء مبيعات ورديتك المفتوحة فقط وبدون مرتجعات.',
    SELF_APPROVAL: 'لا يمكنك اعتماد استرجاعك بنفسك.',
    APPROVAL_REQUIRED: 'يحتاج هذا إلى اعتماد مشرف.',
    DEPOSIT_SETTLED: 'هذا الإيداع تم تأكيده أو إرجاعه من قبل.',
    ACCOUNT_IN_USE: 'لهذا الحساب البنكي رصيد أو قيود غير مطابَقة أو إيداع في الطريق. سوِّها أولاً.',
    ACCOUNT_KIND_LOCKED:
      'لهذا الحساب البنكي حركات، فيبقى حساباً بنكياً. أنشئ حساباً جديداً من النوع الآخر.',
    ADJUSTMENT_DECIDED: 'تم البت في هذا التعديل من قبل.',
    STOCK_MOVED_SINCE_COUNT: 'تحرّك المخزون أثناء الجرد. راجع الحركات وأكّد الجرد.',
    STOCK_RECOUNTED: 'جُرد هذا الصنف مرة أخرى بعد هذا الجرد. ارفضه؛ الجرد الأحدث هو المعتمد.',
    OWNER_FROZEN: 'حساب مالك هذه الشركة مجمَّد من المنصة. تواصل مع الدعم.',
    OWNER_ONLY_SETTING: 'حدود الموافقة وسياساتها يغيّرها المالك فقط.',
    TRANSFER_INVALID: 'نقل الملكية هذا غير صالح أو منتهٍ أو ملغى أو مكتمل.',
    GRANTS_NEED_CONFIRMATION:
      'توجد صلاحيات خاملة في هذا الفرع ستعود للعمل. أكّد الإبقاء عليها أو إلغاءها.',
    PERIOD_CLOSED: 'هذا التاريخ يقع في فترة مقفلة. الفترات المقفلة لا تقبل مستندات جديدة.',
    PERIOD_NOT_CLOSABLE:
      'لا يمكن إقفال هذا الشهر بعد: لم ينتهِ، أو ما زال شهر أسبق مفتوحاً، أو ما زالت أجهزة البيع تستطيع رفع مبيعات تمّت فيه (مهلة العمل دون اتصال).',
    TIMEZONE_LOCKED:
      'لا يمكن تغيير المنطقة الزمنية بعد إقفال أي شهر: الأشهر المقفلة تحتفظ بحدودها.',
    STOCK_ON_HAND: 'ما زال لهذا الصنف رصيد في المخزون. اشطبه أو حوّله قبل أرشفته أو إيقاف تتبعه.',
    BRANCH_IN_USE:
      'ما زال في هذا الفرع مخزون أو نقد أو ورديات مفتوحة أو مستندات مفتوحة. سوِّها قبل تعطيله.',
    COST_UNKNOWN: 'بعض الأصناف بلا تكلفة بعد. حدّد تكلفة المنتج قبل إرسالها.',
    LOSS_DECIDED: 'تم البت في خسارة التحويل هذه من قبل.',
    PAYLOAD_TOO_LARGE: 'الملف كبير جداً.',
    STORE_CLOSED: 'هذا المتجر لا يستقبل الطلبات حاليًا.',
    GATEWAY_NOT_CONFIGURED: 'الدفع الإلكتروني غير متاح بعد. اختر طريقة أخرى.',
    NO_PAYMENT_OPTION: 'اسمح بالدفع عند الاستلام، أو فعّل طريقة دفع إلكتروني جاهزة.',
    PAYMENT_METHOD_REQUIRED: 'هذا المتجر يتطلب دفع الطلب إلكترونيًا.',
    ORDER_UNPAID: 'سجّل الدفع قبل إكمال الطلب.',
    RENAME_LIMIT: 'يمكن تغيير عنوان المتجر مرة واحدة في اليوم.',
    SLOT_FULL: 'هذا الموعد مكتمل الحجز. اختر موعدًا آخر.',
    PLACE_TAKEN: 'بعض هذه المناطق تابعة لمنطقة توصيل أخرى.',
    LAST_STORE_BRANCH: 'يحتاج المتجر فرعًا نشطًا واحدًا على الأقل لتجهيز الطلبات.',
    OUTSIDE_HOURS: 'المتجر مغلق الآن.',
    PROMOTION_INVALID: 'لا يمكن استخدام رمز العرض هذا.',
    OPTIONS_INVALID: 'تغيّرت خيارات أحد المنتجات. اخترها من جديد من صفحة المنتج.',
    ACCOUNTS_DISABLED: 'هذا المتجر لا يوفر حسابات.',
    EMAIL_TAKEN: 'يوجد حساب بهذا البريد.',
    PHONE_TAKEN: 'يوجد حساب بهذا الهاتف.',
    ASSET_IN_USE: 'هذه الصورة مستخدمة في تصميم المتجر. احذفها من الأقسام أولًا.',
    ASSET_LIMIT_REACHED: 'يحتفظ المتجر بـ 200 صورة تصميم كحد أقصى. احذف بعضها أولًا.',
    PAYMENT_SIGNATURE_INVALID: 'تعذّر التحقق من إشعار الدفع.',
    MINIMUM_ORDER: 'قيمة الطلب أقل من الحد الأدنى للمتجر.',
    LINK_LIMIT_REACHED: 'صفحة الروابط تتسع لخمسين رابطًا كحد أقصى.',
    PLAN_LIMIT_REACHED: 'تم الوصول إلى حد خطة الاشتراك. اطلب من إدارة المنصة تغيير الخطة.',
    PLAN_FEATURE_UNAVAILABLE: 'خطة اشتراكك لا تشمل هذه الميزة.',
    PLAN_CHANGE_BLOCKED: 'الاستخدام الحالي للتاجر لا يتوافق مع هذه الخطة.',
    MERCHANT_SUSPENDED: 'حساب الشركة موقوف. تواصل مع دعم المنصة.',
    SESSION_LOCKED: 'نقطة البيع مقفلة. أدخل كلمة المرور.',
    UNLOCK_SHARED_ACCOUNT:
      'هذا الشخص يعمل أيضًا في شركة أخرى، وقفل الدخول يحمي حسابه هناك أيضًا. أرسل له رابط إعادة تعيين كلمة المرور بدلًا من ذلك.',
    MALFORMED_REQUEST: 'تعذّرت قراءة الطلب. أعد تحميل الصفحة وحاول مجددًا.',
    NETWORK_BLOCKED:
      'شبكة الإنترنت اللي تستخدمها (مثل شبكة العمل) منعت هذا الطلب بفلتر مواقع. جرّب بيانات الهاتف، أو اطلب من قسم تقنية المعلومات عندكم السماح بموقع arabatapp.com.',
    METHOD_NOT_ALLOWED: 'هذا الإجراء غير متاح هنا. أعد تحميل الصفحة وحاول مجددًا.',
    INTERNAL_ERROR: 'حدث خطأ من جهتنا. حاول مجددًا بعد قليل.',
    ORIGIN_REJECTED: 'وصل الطلب من عنوان غير معروف. افتح التطبيق من رابطه المعتاد.',
    MOVEMENT_DECIDED: 'تمت الموافقة على هذا الطلب أو رفضه مسبقًا. أعد تحميل الصفحة.',
    PENDING_MOVEMENTS: 'يوجد سحب نقدي ينتظر قرار المدير. اسحب الطلب أو انتظر القرار.',
    ORDER_OVERPAID: 'هذه الدفعة أكبر من المتبقي على أمر الشراء.',
    ASSISTANT_DISABLED: 'المساعد غير متاح حاليًا.',
    INVALID_STATE: 'لا يمكن تنفيذ هذا في حالته الحالية. أعد تحميل الصفحة وراجعه.',
    RECEIVE_EXCEEDS_ORDER: 'هذا أكثر من المتبقي في الطلب. راجع الكميات.',
    SUPPLIER_INACTIVE: 'هذا المورد غير نشط. فعّله أو اختر موردًا آخر.',
    CUSTOMER_INACTIVE: 'هذا العميل غير نشط. اختر عميلًا آخر أو فعّله.',
    DUPLICATE_PHONE: 'رقم الهاتف هذا مسجّل لعميل آخر.',
    MODULE_DISABLED: 'وحدة المطعم غير مفعّلة لهذه الشركة.',
    TABLE_OCCUPIED: 'على هذه الطاولة طلب مفتوح. افتح ذلك الطلب بدلًا من طلب جديد.',
    ITEM_ALREADY_PAID: 'هذا الصنف مدفوع. استخدم الاسترجاع بدلًا من ذلك.',
    MODIFIER_INVALID: 'الإضافات المختارة لا تناسب هذا الصنف. راجع الاختيارات.',
    DEVICE_REVOKED: 'تم حذف هذا الجهاز. سجّله من جديد.',
    NOT_OWN_SALE: 'يعيد الجهاز طباعة أو تعديل مبيعاته فقط.',
    RECEIPT_NUMBER_INVALID: 'رقم الإيصال هذا غير صالح لهذا الجهاز.',
    RECEIPT_NUMBER_TAKEN: 'رقم الإيصال هذا مستخدم من قبل.',
    TOTALS_MISMATCH: 'مجاميع عملية البيع غير متطابقة. اطلب من المدير مراجعتها.',
    UNKNOWN_VARIANT: 'صنف في عملية البيع هذه لم يعد موجودًا. اطلب من المدير مراجعتها.',
    MEMBER_NOT_ALLOWED: 'لم يكن هذا الموظف نشطًا في الشركة في ذلك الوقت.',
    WRONG_DEVICE: 'هذا يخص جهازًا أو فرعًا آخر.',
    SHIFT_NOT_ACCEPTED: 'رفض الخادم هذه الوردية؛ البيع متوقف حتى تُقبل.',
    NETWORK: 'تعذّر الاتصال بالخادم. تحقق من الاتصال.',
    UNKNOWN: 'حدث خطأ غير متوقع.',
  },
};
